<template>
  <div>
    <div class="mui-card">
      <div class="mui-card-footer">
        <span class="mui-card-footer-left">设施名称：</span>
        <span>苏州创业园2号楼</span>
      </div>
      <div class="mui-card-footer">
            <span class="mui-card-footer-left">设施类别：</span>
            <Select style="width:200px" v-model="formItem.sendValue">
              <Option v-for="item in formItem.stateList" :value="item.value" :key="item.value" name="sendValue">
                {{ item.label }}
              </Option>
            </Select>
      </div>
      <div class="mui-card-footer">
        <span class="mui-card-footer-left">设施评价：</span>
        <span>
          <Rate></Rate>
        </span>
      </div>
      <div class="mui-card-footer">
        <span class="mui-card-footer-left">设施图片：</span>
        <div class="img-files flex">
          <div v-if='imgs.length>0' class="flex">
            <div class="img-box" v-for="(item, i) in imgs" :key='i' >
              <img :src="item" alt=""> <span @click="del(i)"><i class="el-icon-delete"></i></span>
            </div>
          </div>
          <div class="img-file" v-if='imgs.length < size'>
            <input type="file" id='files' @change='fileChange'>
            <label for="files">上传图片</label>
          </div>
        </div>
      </div>
      <div class="mui-card-footer">
        <span class="mui-card-footer-left">设施描述：</span>
        <span>
          <textarea name="" id="" cols="30" rows="10" v-model="textAreaValue"></textarea>
          <span class="mui-badge" @click="addComment('1111')" ref="comment1">1111</span>
          <span class="mui-badge" @click="addComment('2222')" ref="comment2">2222</span>
          <span class="mui-badge" @click="addComment('3333')" ref="comment3">3333</span>
        </span>
      </div>
    </div>
    <div class="mui-card">
      <mt-button type="primary">上传</mt-button>
    </div>
  </div>
</template>

<script>
import Rate from '../common/Rate'
import { compressImage } from '../../utils/compressImage'
export default {
  name: 'facilitiesDetail',
  data () {
    return {
      textAreaValue: '',
      formItem: {
        stateList: [
          {
            value: '0',
            label: '点击选择'
          },
          {
            value: '1',
            label: '无障碍洗手间'
          },
          {
            value: '2',
            label: '无障碍席位'
          },
          {
            value: '3',
            label: '无障碍客房'
          },
          {
            value: '4',
            label: '无障碍通道'
          }
        ]
      },
      imgs: [],
      imgfiles: [],
      size: 5
    }
  },
  methods: {
    fileChange() {
      var _this = this
      var event = window.event
      var file = event.target.files
      var reader = new FileReader()
      let formData = new FormData()
      compressImage(file[0], 800000, 6000000, 0.4).then((res) => {
        console.log('压缩之后图片尺寸大小: ', res.size / 1024)
        console.log('实际压缩率： ', ((file[0].size - res.size) / file[0].size * 100).toFixed(2) + '%');
        formData.append('file', new File([res], 'my-image1.png', { type: 'image/png' }))
        _this.imgfiles.push(formData)
        reader.readAsDataURL(new File([res], 'my-image1.png', { type: 'image/png' }))
        reader.onload = function (e) {
          _this.imgs.push(e.target.result)
        }
        _this.submitImage(0)
        this.imgfiles.splice(0, 1)
      })

    },
    del (i) {
      this.imgfiles.splice(i, 1)
      this.imgs.splice(i, 1)
      console.log(this.imgs)
      console.log(this.imgfiles)
    },
    addComment (val) {
      this.textAreaValue = this.textAreaValue + val
    }
  },
  components: {
    Rate: Rate
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.img-files {
  width: 70%;
}
.img-file{
  float: right;
}
.img-box{
  width: 160px;
  position: relative;
  border:1px solid #e6e6e6;
  margin-right: 20px;
  background: #f6f6f6;
  img{
    width: 160px;
  }
  span {
    position: absolute;
    top:5px;
    right: 10px;
    color: red;
    display: none;
  }
  &:hover span{
    display: block;
  }
}
.img-file{
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  font-size: 30px;
  text-align: center;
  border: 1px #333 dashed;
  justify-content: center;
  margin: 0;
  position: relative;
  > input {
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  >label {
    position: absolute;
    font-size: 14px;
    color: #333;
  }
}

.mui-card{
  button{
    width: 100%;
  }
}

.mui-card-header{
  font-size: 15px;
}

select{
  margin: 0px;
  padding: 0px;
  background-color: #EFEFEF;
  text-align: center;
}

.mui-card-footer-left{
  width: 25%;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Build/FacilitiesDetail.vue